import { render, staticRenderFns } from "./multiindex.vue?vue&type=template&id=193d0bb1&scoped=true&"
import script from "./multiindex.vue?vue&type=script&lang=js&"
export * from "./multiindex.vue?vue&type=script&lang=js&"
import style0 from "./multiindex.vue?vue&type=style&index=0&id=193d0bb1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193d0bb1",
  null
  
)

export default component.exports